import { Plane, PartyPopper, Briefcase } from 'lucide-react';

export const ServicesSection = ({ t }) => {
  const services = [
    {
      id: 'airport',
      icon: Plane,
      title: t('services.airport.title'),
      description: t('services.airport.description'),
      image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=600&q=80'
    },
    {
      id: 'events',
      icon: PartyPopper,
      title: t('services.events.title'),
      description: t('services.events.description'),
      image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80'
    },
    {
      id: 'business',
      icon: Briefcase,
      title: t('services.business.title'),
      description: t('services.business.description'),
      image: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=600&q=80'
    }
  ];

  return (
    <section id="services" className="py-24 lg:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="label-luxury">{t('services.title')}</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light text-white mt-4 tracking-tighter" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            {t('services.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id}
              className="group relative overflow-hidden bg-[#111111] border border-white/5 hover:border-[#C5A059]/30 transition-all duration-500"
              data-testid={`service-card-${service.id}`}
            >
              {/* Image */}
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-500"
                />
              </div>
              
              {/* Content */}
              <div className="p-6 lg:p-8">
                <div className="w-12 h-12 bg-[#C5A059]/10 flex items-center justify-center mb-4">
                  <service.icon className="text-[#C5A059]" size={24} />
                </div>
                <h3 className="text-xl font-light text-white mb-3" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                  {service.title}
                </h3>
                <p className="text-white/50 text-sm leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
